import { useReducer } from "react";
import AppContext from "./appContext";
import appReducer from "./appReducer";
import { LOGIN, LOGOUT, SET_IS_AUTH, UPDATE_SESSION } from "./appActions";

let userLoad = JSON.parse(sessionStorage.getItem('user'))
let userToken = sessionStorage.getItem('token')

const initialState = {
    isAuth: userLoad ? true : false,
    // messages: [], // {id:1, content: "", title:"", type:"",timeout:5000}
    user: userLoad,
    token: userToken,
};

const AppState = ({ children }) => {
    const [state, dispatch] = useReducer(appReducer, initialState);

    const login = (user) => {
        dispatch({
            type: LOGIN,
            payload:user
        });
    };
  
    const logout = () => {
        dispatch({
            type:LOGOUT
        });
    };

    const setIsAuth = (isAuth) => {
        dispatch({
            type: SET_IS_AUTH,
            payload:isAuth
        })
    };

    const updateSession = (user) => {
        dispatch({
            type: UPDATE_SESSION,
            payload: user
        })
    }
    return (
        <AppContext.Provider value={{ ...state, login, logout, setIsAuth, updateSession }}>
            {children}
        </AppContext.Provider>
    )
}
export default AppState;